import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleModal } from 'data/actions/modals';
import { paymentGate as paymentGateType } from 'data/types/payment.types';
import { modalsSelector, modalOptionsSelector } from 'data/selectors/modals';

import { SystemModal } from 'components/commonStyles';
import StripeGate from 'components/paymentGate/stripe';
import FastSpringGate from 'components/paymentGate/fastSpring';

import { ModalTitle, CloseIcon } from '../baseModal/styles';

import { ContentWrapper } from './styles';

const BillingModal = () => {
  const dispatch = useDispatch();
  const { visible } = useSelector(modalsSelector);
  const {
    paymentGate,
    billingCycle,
    plan,
    bulkId,
    phoneSearchPlan,
    phoneSearchQuantity,
    selectSubscriptionQuantity,
    payDueTodayPhoneSearch,
  } = useSelector(modalOptionsSelector);

  const PaymentGate = paymentGate === paymentGateType.FAST_SPRING ? FastSpringGate : StripeGate;

  const handleClose = () => dispatch(toggleModal('billing', false));

  return (
    <SystemModal
      visible={visible}
      title={
        <ModalTitle>
          Checkout
          <CloseIcon onClick={handleClose} className="ic_close" />
        </ModalTitle>
      }
      closable={false}
      width={420}
      footer={false}
      onCancel={handleClose}
      bodyStyle={{ padding: 0 }}
    >
      <ContentWrapper>
        <PaymentGate
          billingCycle={billingCycle}
          plan={plan}
          bulkId={bulkId}
          phoneSearchPlan={phoneSearchPlan}
          phoneSearchQuantity={phoneSearchQuantity}
          payDueTodayPhoneSearch={payDueTodayPhoneSearch}
          selectSubscriptionQuantity={selectSubscriptionQuantity}
        />
      </ContentWrapper>
    </SystemModal>
  );
};

export default BillingModal;
